import { Navigate, Outlet } from "react-router-dom";
import useAuth from "@/hooks/useAuth";

function AuthenticatedRoute() {
  const { isAuthenticated, isInitializing } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
}

export default AuthenticatedRoute;
